/* eslint-disable max-len */
/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
// import {factorData} from '../../../pages/dashboard/Utils/Metrics/constants/commonFunctions';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

const listOfActivity = async (year: string): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const companyID = useCompanyStore.getState().companyId;

  try {
    const response = await axios.request({
      method: CRUDMethods.GET,
      // url: `${API_BASE_URL}${API_ENDPOINT_JSON.CONFIGURATOR.orgHierarchyChart}/${companyID}/${selectedYear}/${chartType}`,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.DASHBOARD.listOfActivity}/${companyID}/${year}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {}
    });

    return response.data;
  } catch (err) {
    console.log('err:', err);
  }
};

export default listOfActivity;
